
import { TeamPatch } from "../../team/types/team.types";
import { checkValidity } from "../../../utils/inputValidityChecker";


export  interface CheckTeamInputResult {
    isErrorName: boolean;
    isErrorDescription: boolean;
    isErrorProject: boolean;
    isErrorMembers: boolean;
    isErrorManager: boolean;
    allFalse: boolean;



}
export const validationInputCreationTeam = (team:  TeamPatch) => {
    const initCheck = {
        isErrorName: false,
        isErrorDescription: false,
        isErrorProject: false,
        isErrorMembers: false,
        isErrorManager: false,
        allFalse: true
    }

    let errors = initCheck;


    if (!checkValidity(team.team_name, 'text-not-empty')){
        errors.isErrorName = true;
        errors.allFalse = false;
    }
    if(team.team_role !== "COMPTA_ADMIN" && team.team_role !== "TECH_SUPERVISOR" && team.team_manager && team.team_manager.length === 0){
        errors.isErrorManager = true;
        errors.allFalse = false;
    }

    if(team.team_users?.length === 0){
        errors.isErrorMembers = true;
        errors.allFalse = false;
    }

    return errors;

}